import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Dashboard from './pages/Dashboard';
import VideoGeneration from './pages/VideoGeneration';
import StreamingAvatar from './pages/StreamingAvatar';
import Jobs from './pages/Jobs';
import ApiDocs from './pages/ApiDocs';

function App() {
    return (
        <div className="min-h-screen bg-gradient-to-br from-[#1e3a8a] via-[#312e81] to-[#1e3a8a] relative">
            <div className="absolute inset-0 bg-gradient-to-tr from-[#3b82f6]/10 via-[#8b5cf6]/10 to-[#6366f1]/10"></div>
            <div className="absolute inset-0 opacity-30">
                <div className="absolute top-10 left-10 w-32 h-32 bg-gradient-to-br from-[#3b82f6] to-[#8b5cf6] rounded-full blur-3xl animate-pulse"></div>
                <div className="absolute bottom-20 right-20 w-40 h-40 bg-gradient-to-br from-[#8b5cf6] to-[#6366f1] rounded-full blur-3xl animate-pulse delay-1000"></div>
                <div className="absolute top-1/2 left-1/3 w-24 h-24 bg-gradient-to-br from-[#6366f1] to-[#3b82f6] rounded-full blur-2xl animate-pulse delay-500"></div>
            </div>
            <div className="relative z-10">
                <Navbar />

                <Routes>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/video-generation" element={<VideoGeneration />} />
                    <Route path="/streaming-avatar" element={<StreamingAvatar />} />
                    <Route path="/jobs" element={<Jobs />} />
                    <Route path="/api-docs" element={<ApiDocs />} />

                    {/* Default redirect to dashboard */}
                    <Route path="/" element={<Navigate to="/dashboard" />} />
                </Routes>
            </div>
        </div>
    );
}

export default App;